import Container from 'atoms/Container';
import Button from 'layout/atoms/Button';
import Grid from 'layout/atoms/Grid';
import ProjectsList from 'layout/organisms/ProjectsList/ProjectsList';
import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { selectWorkspaceData } from 'store/workspaceSlice';
import { AddProject } from './AddProject';
import { ProjectsArchive } from './ProjectsArchive';
import WorkspaceTasks from './WorkspaceTasks';
import { useNavigate } from 'react-router';

const PlanPage = () => {
    const workspaceData = useSelector(selectWorkspaceData);
    const [displayArchive, setDisplayArchive] = useState<boolean>(false);

    useEffect(() => {}, []);
    const navigate = useNavigate();

    return (
        <>
            <Container narrow>
                <WorkspaceTasks />
            </Container>
            <ProjectsList />
            <Container narrow>
                <Grid columns={1} gap={12}>
                    {workspaceData.projects.length === 0 && (
                        <div
                            className={'empty-state'}
                            style={{
                                textAlign: 'center',
                                padding: '60px 20px',
                                display: 'flex',
                                flexDirection: 'column',
                                alignItems: 'center',
                                background: 'var(--box-background)',
                                borderRadius: 'var(--radius)',
                                border: '1px solid var(--grey)',
                                marginBottom: '24px',
                            }}
                        >
                            <div
                                style={{
                                    width: '80px',
                                    height: '80px',
                                    borderRadius: '50%',
                                    background:
                                        'linear-gradient(135deg, var(--primary-color, #007AFF), var(--secondary-color, #5856D6))',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    marginBottom: '24px',
                                    fontSize: '32px',
                                }}
                            >
                                📋
                            </div>
                            <h3
                                style={{
                                    margin: '0 0 12px 0',
                                    fontSize: '20px',
                                    fontWeight: '600',
                                    color: 'var(--text)',
                                }}
                            >
                                Welcome to your workspace!
                            </h3>
                            <p
                                style={{
                                    margin: '0 0 24px 0',
                                    fontSize: '16px',
                                    lineHeight: '1.5',
                                    color: 'var(--text)',
                                    opacity: 0.7,
                                    maxWidth: '400px',
                                }}
                            >
                                Organize your tasks into projects for better
                                management and focus. Projects help you group
                                related work and track progress effectively.
                            </p>
                            <div
                                style={{
                                    fontSize: '14px',
                                    color: 'var(--text)',
                                    opacity: 0.6,
                                    fontWeight: '500',
                                }}
                            >
                                👇 Create your first project below
                            </div>
                        </div>
                    )}
                    <AddProject />
                    <div>
                        {!workspaceData.access.archives && (
                            <small
                                style={{ cursor: 'pointer' }}
                                onClick={() => navigate('/subscription')}
                            >
                                +{workspaceData.archivedProjectsCount} archived
                                projects
                            </small>
                        )}
                        {workspaceData.access.archives &&
                            workspaceData.archivedProjectsCount > 0 &&
                            !displayArchive && (
                                <Button
                                    theme="blank"
                                    onClick={() => setDisplayArchive(true)}
                                >
                                    Show archived projects (
                                    {workspaceData.archivedProjectsCount})
                                </Button>
                            )}
                        {workspaceData.access.archives &&
                            workspaceData.archivedProjectsCount > 0 &&
                            displayArchive && (
                                <Button
                                    theme="blank"
                                    onClick={() => setDisplayArchive(false)}
                                >
                                    Hide archived projects
                                </Button>
                            )}
                    </div>
                </Grid>
            </Container>
            <Container narrow>
                {workspaceData.archivedProjectsCount > 0 && displayArchive && (
                    <ProjectsArchive />
                )}
            </Container>
        </>
    );
};

export default PlanPage;
